import { faDotCircle } from "@fortawesome/pro-solid-svg-icons/faDotCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Checked radio button icon.
 * @returns Icon.
 */
const CheckedIcon = () => (
    <FontAwesomeIcon aria-label="radio-checked-icon" fixedWidth={true} icon={faDotCircle} size="lg" />
);

export default CheckedIcon;
